import { render, staticRenderFns } from "./MessageLoading.vue?vue&type=template&id=70ac9af9&"
import script from "./MessageLoading.vue?vue&type=script&lang=js&"
export * from "./MessageLoading.vue?vue&type=script&lang=js&"
import style0 from "./MessageLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports